module.exports = __webpack_public_path__ + "img/样例1.7e48af60.png";